"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Note = function Note(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 25 25",
    fill: "none"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("rect", {
    width: "25",
    height: "25",
    fill: "transparent"
  }), _react.default.createElement("path", {
    d: "M12.5 17.1875C12.3667 17.1875 12.2334 17.1366 12.1317 17.035C11.9283 16.8316 11.9283 16.5018 12.1317 16.2984L18.3818 10.0484C18.5851 9.84503 18.9149 9.84503 19.1183 10.0484C19.3217 10.2518 19.3217 10.5816 19.1183 10.785L12.8683 17.035C12.7666 17.1367 12.6333 17.1875 12.5 17.1875L12.5 17.1875Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M16.6667 6.77082H8.33333C8.04569 6.77082 7.8125 6.53763 7.8125 6.24999C7.8125 5.96235 8.04569 5.72916 8.33333 5.72916H16.6667C16.9543 5.72916 17.1875 5.96235 17.1875 6.24999C17.1875 6.53763 16.9543 6.77082 16.6667 6.77082Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M16.6667 19.2708H8.33333C8.04569 19.2708 7.8125 19.0376 7.8125 18.75C7.8125 18.4623 8.04569 18.2292 8.33333 18.2292H16.6667C16.9543 18.2292 17.1875 18.4623 17.1875 18.75C17.1875 19.0376 16.9543 19.2708 16.6667 19.2708Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M8.33333 19.2708C8.04569 19.2708 7.8125 19.0376 7.8125 18.75V6.24999C7.8125 5.96235 8.04569 5.72916 8.33333 5.72916C8.62098 5.72916 8.85417 5.96235 8.85417 6.24999V18.75C8.85417 19.0376 8.62098 19.2708 8.33333 19.2708Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M16.6666 19.2708C16.379 19.2708 16.1458 19.0376 16.1458 18.75V6.24999C16.1458 5.96235 16.379 5.72916 16.6666 5.72916C16.9543 5.72916 17.1875 5.96235 17.1875 6.24999V18.75C17.1875 19.0376 16.9543 19.2708 16.6666 19.2708Z",
    fill: props.foregroundColor
  }));
};

Note.defaultProps = {
  altText: "Note",
  foregroundColor: "#2D5AB4"
};
Note.propTypes = {
  altText: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = Note;
exports.default = _default;